import React, { FC, useState } from 'react';
import s from './preview.module.scss';
import { Toy } from '@specs/views';
import { useGetModel } from '@services/toys/hooks/useGetModel';
import dynamic from 'next/dynamic';
import { PreviewAr } from '@components/Pages/ToyPage/Preview/PreviewAr';
import { useHeaderHeight } from '@hooks/useHeaderHeight/useHeaderHeight';
import { useGetModelAdmin } from '@services/toys/hooks/useGetModelAdmin';
import { PublicationType } from '@specs/specs';
import { useTranslation } from '@hooks/useTranslation';
import { RarityIcon } from '@components/UIKit/RarityIcon/RarityIcon';
import { OptimizedImage } from '@components/OptimizedImage/OptimizedImage';
import { SpriteIcon } from '@components/Sprites/SpriteIcon';
const ModelViewer = dynamic(() => import('@components/ModelViewer/ModelViewer').then(module => module.ModelViewer), {
  ssr: false
});
interface Props {
  imageid: Toy.Single['imageid'];
  id: Toy.Single['id'];
  slug: Toy.Single['slug'];
  preview: Toy.Single['preview'];
  publication: Toy.Single['publication'];
  raritytype: Toy.Single['raritytype'];
  showModelViewer: boolean;
  canScanQR: boolean;
}
export const Preview: FC<Props> = ({
  id: toyId,
  slug,
  imageid,
  showModelViewer,
  canScanQR,
  preview,
  publication,
  raritytype
}) => {
  const {
    translate: tr
  } = useTranslation();
  const {
    data: privateModel
  } = useGetModel({
    toyId
  }, {
    enabled: showModelViewer && !preview
  });
  const {
    data: previewModel
  } = useGetModelAdmin({
    toyId
  }, {
    enabled: showModelViewer && preview
  });
  const [load, setLoad] = useState(false);
  const headerHeight = useHeaderHeight();
  const model = preview ? previewModel : privateModel;
  const isTwin = publication === PublicationType.TWIN;
  return <div className={s.preview} style={{
    top: headerHeight
  }} data-sentry-component="Preview" data-sentry-source-file="Preview.tsx">
            <div className={s.preview__body}>
                <div className={s.preview__model}>
                    <ModelViewer model={model} showModelViewer={showModelViewer} setLoad={setLoad} load={load} data-sentry-element="ModelViewer" data-sentry-source-file="Preview.tsx" />
                </div>
                {!load && <OptimizedImage boxClassName={s.preview__image} path={'/toys/main'} alt={slug} title={tr({
        id: 'toy.page.image.title'
      }, {
        name: slug
      })} cdnId={imageid} loading={'eager'} fill />}
                <div className={s.preview__label}>
                    <div className={s.preview__publication}>
                        {tr({
            id: publication === PublicationType.TWIN ? 'toy.page.digital.twin' : 'toy.page.digital.toy'
          })}
                    </div>

                    <PreviewAr showModelViewer={showModelViewer} canScanQR={canScanQR} model={model} data-sentry-element="PreviewAr" data-sentry-source-file="Preview.tsx" />

                    {raritytype && <RarityIcon rarityId={raritytype} width={40} height={40} />}
                    {isTwin && <SpriteIcon name={'twin'} width={40} height={40} />}
                </div>
            </div>
        </div>;
};